var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'photo-item-root': true },style:({
  width: (_vm.width + "px"),
  height: (_vm.height + "px"),
  transform: ("translate(" + _vm.left + "px, " + _vm.top + "px) scale(" + _vm.scale + ")"),
  transitionDuration: (_vm.animDur + "ms"),
  zIndex: ("" + (_vm.selected ? 2 : 1))
}),on:{"click":_vm.clickItem}},[(_vm.visible)?_c('div',{class:{ 'item-inner': true, selected: _vm.selected },style:({
    backgroundColor: ("" + _vm.bgColor)
  })},[_c('div',{staticClass:"img thumb",style:({
      backgroundImage: ("url(" + _vm.thumbSrc + ")")
    })}),(_vm.selected || _vm.srcLoaded)?_c('div',{staticClass:"img org",style:({ backgroundImage: ("url(" + _vm.src + ")") })}):_vm._e(),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }